<template>
    <Button :href="adminUrl" color="brand" variant="inline" size="xs">
        <icon icon="hero/outline/user-circle" class="w-4 h-4 mr-1" />
        <span>{{ lang('customers::customers.actions.view_customer_card') }}</span>
    </Button>
</template>

<script setup lang="ts">
import { lang } from '@/lang/composable';

interface Props {
    customerId: number;
    email?: string | null;
    name?: string | null;
    touchpointCount?: number;
    adminUrl: string;
}

defineProps<Props>();
</script>
